import { createSlice } from "@reduxjs/toolkit";

import type { ConnectionDetailData } from "../../../pages/LeadDebugPage/LeadDebugPage.types";
import {
    getConnectionDetailAsync,
    getDebugModeResultsAsync,
    setDebugModeAsync,
} from "./leadDebug.asyncActions";
import { defaultPagination, initialState } from "./leadDebug.types";

export const leadDebugSlice = createSlice({
    name: "leadDebug",
    initialState,
    reducers: {
        clearLeadDebug: (state) => {
            state.connectionDetail = null;
            state.debugLogs = [];
            state.pagination = defaultPagination;
            state.selectedLogId = null;
        },
        setSelectedLogId: (state, action: { payload: number | null }) => {
            state.selectedLogId = action.payload;
        },
        hydrateConnectionDetail: (
            state,
            action: { payload: ConnectionDetailData },
        ) => {
            state.connectionDetail = action.payload;
            state.connectionLoading = false;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getConnectionDetailAsync.pending, (state) => {
                state.connectionLoading = true;
            })
            .addCase(getConnectionDetailAsync.fulfilled, (state, action) => {
                state.connectionLoading = false;
                state.connectionDetail = action.payload;
            })
            .addCase(getConnectionDetailAsync.rejected, (state) => {
                state.connectionLoading = false;
            })
            .addCase(getDebugModeResultsAsync.pending, (state) => {
                state.logsLoading = true;
            })
            .addCase(getDebugModeResultsAsync.fulfilled, (state, action) => {
                state.logsLoading = false;
                state.debugLogs = action.payload.debug_logs;
                state.pagination = action.payload.pagination;
            })
            .addCase(getDebugModeResultsAsync.rejected, (state) => {
                state.logsLoading = false;
            })
            .addCase(setDebugModeAsync.pending, (state, action) => {
                // Optimistic: treat toggle as succeeded immediately (no loader).
                state.setDebugModeLoading = true;
                const { debug_mode } = action.meta.arg;
                if (state.connectionDetail?.connection_detail) {
                    state.connectionDetail.connection_detail.debug_mode =
                        debug_mode;
                }
                if (debug_mode === 0) {
                    state.debugLogs = [];
                    state.pagination = defaultPagination;
                    state.selectedLogId = null;
                }
            })
            .addCase(setDebugModeAsync.fulfilled, (state, action) => {
                state.setDebugModeLoading = false;
                if (state.connectionDetail?.connection_detail) {
                    state.connectionDetail.connection_detail.debug_mode =
                        action.payload.debug_mode;
                }
                if (action.payload.debug_mode === 0) {
                    state.debugLogs = [];
                    state.pagination = defaultPagination;
                    state.selectedLogId = null;
                }
            })
            .addCase(setDebugModeAsync.rejected, (state, action) => {
                state.setDebugModeLoading = false;
                // Revert optimistic debug_mode on failure.
                const { debug_mode } = action.meta.arg;
                if (state.connectionDetail?.connection_detail) {
                    state.connectionDetail.connection_detail.debug_mode =
                        debug_mode === 1 ? 0 : 1;
                }
            });
    },
});

export default leadDebugSlice.reducer;
export const { clearLeadDebug, setSelectedLogId, hydrateConnectionDetail } =
    leadDebugSlice.actions;
